module.exports = __webpack_public_path__ + "assets/06c175fb0d0d39997fbad5cb464813fc.png";